import PropTypes from 'prop-types';
import { toast } from 'sonner';
import Icon from 'Components/Atoms/Icon/Icon';
import SnackbarCard from './SnackbarCard';
import SnackbarClose from './SnackbarClose';
import SnackbarLayout from './SnackbarLayout';
import SnackbarContent from './SnackbarContent';
import SnackbarTitle from './SnackbarTitle';

export default function SnackbarError({ id, message, description }) {
    return (
        <SnackbarCard variant="error">
            <SnackbarClose onClick={() => toast.dismiss(id)} />
            <SnackbarLayout>
                <div className="shrink-0">
                    <Icon name="exclamation-triangle" className="text-danger" color="currentColor" size={24} />
                </div>
                <SnackbarContent className="pr-4">
                    <SnackbarTitle>{message}</SnackbarTitle>
                    {description && <div className="text-gray-500 text-sm mt-0.5">{description}</div>}
                </SnackbarContent>
            </SnackbarLayout>
        </SnackbarCard>
    );
}

SnackbarError.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    message: PropTypes.string.isRequired,
    description: PropTypes.string,
};
